// A YYYY-MM-DD value is a calendar date. Parsing it with new Date(value) means
// UTC midnight, which shows the day before in US time zones.
export function parseCalendarDate(value) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ''));
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(value);
}

export function formatShortDate(value) {
  try { return parseCalendarDate(value).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch { return '\u2014'; }
}
